import React, { useEffect } from "react";
import DubaiImg from '../Images/Dubai.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function Dubai() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={DubaiImg} alt="Dubai" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Dubai</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <p className="text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Our architectural design team, consisting of highly skilled engineers and architects, has consistently delivered world-class projects across international markets. With years of hands-on experience, we have proudly completed a range of iconic developments in Dubai — one of the world’s most dynamic and design-forward cities.
                    </p>
                    <p className="mb-8 text-lg tracking-wider text-gray-700 font-light">
                        Working in Dubai has given our team a deep understanding of international standards, diverse client expectations, and cutting-edge design trends. From luxury residential towers to commercial spaces, our portfolio reflects creativity, precision, and technical excellence.
                    </p>
                    <p className="mb-8 text-lg tracking-wider text-gray-700 font-light">
                        This international exposure not only sharpens our vision but also enables us to bring globally inspired solutions to every project we undertake. Whether in the Middle East or beyond, our commitment remains the same — to craft innovative spaces that stand the test of time.
                    </p>
                </div>
                <div className="mb-8">
                    <h1 className="text-2xl font-semibold mb-4">Corporate Social Environmental Responsibility (CSER)</h1>
                    <p className="mb-6 text-gray-800 text-lg font-light tracking-wider">
                        Our CSER policy is driven by a desire to deliver lasting benefits by applying our sustainable principles to our own operations.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <Link to='/studio/corporate-social-responsibility'>
                        <button className="bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Corporate Social Environmental Responsibility</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Dubai;